"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoAIGetRequest = autoAIGetRequest;
exports.autoAIPostRequest = autoAIPostRequest;
const periodTypes_1 = __importDefault(require("../table/v1/periodTypes"));
async function autoAIGetRequest(branchId, userId, start, end) {
    const endPath = end ? `/${end}` : "";
    const url = `/dashboard/${userId}/autoai/${start}${endPath}?c=${branchId}`;
    try {
        const res = await fetch(url, {
            method: "GET",
            headers: { "Content-Type": "application/json", },
            cache: "no-store",
        });
        return await res.json();
    }
    catch (err) {
        throw new Error();
    }
}
async function autoAIPostRequest(branchId, userId, payload) {
    const url = payload.isEditExisting
        ? `/dashboard/${userId}/autoai/edit?c=${branchId}`
        : `/dashboard/${userId}/autoai?c=${branchId}`;
    const data = new URLSearchParams({
        list: payload.list,
        date: payload.date,
        until: payload.until,
        tags: payload.tags,
        autoSel: payload.autoSel,
        instructions: payload.instructions,
        provider: payload.provider,
    });
    if (payload.list === periodTypes_1.default.DAY) {
        data.append("roleIds", payload.roleIds || "");
    }
    if (payload.sendSkills) {
        data.append("sendSkills", "true");
    }
    if (payload.sendODays) {
        data.append("sendODays", "true");
    }
    for (const date of payload.excludedDates) {
        data.append("excludedDates", date);
    }
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data.toString(),
        });
        if (!res.ok) {
            throw new Error();
        }
    }
    catch (err) {
        throw err;
    }
}
